import api from './api';

const taxInvoiceService = {
  // Get all tax invoices with pagination and filters
  getAllTaxInvoices: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      // Add pagination parameters
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      
      // Add filter parameters
      if (params.search) queryParams.append('search', params.search);
      if (params.status) queryParams.append('status', params.status);
      if (params.paymentStatus) queryParams.append('paymentStatus', params.paymentStatus);
      if (params.customer) queryParams.append('customer', params.customer);
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      if (params.excludeStatus) queryParams.append('excludeStatus', params.excludeStatus);
      
      const response = await api.get(`/tax-invoices?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching tax invoices:', error);
      throw error;
    }
  },

  // Get tax invoice by ID
  getTaxInvoiceById: async (id) => {
    try {
      const response = await api.get(`/tax-invoices/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching tax invoice:', error);
      throw error;
    }
  },

  // Create new tax invoice
  createTaxInvoice: async (taxInvoiceData) => {
    try {
      const response = await api.post('/tax-invoices', taxInvoiceData);
      return response.data;
    } catch (error) {
      console.error('Error creating tax invoice:', error);
      throw error;
    }
  },

  // Update tax invoice
  updateTaxInvoice: async (id, taxInvoiceData) => {
    try {
      const response = await api.put(`/tax-invoices/${id}`, taxInvoiceData);
      return response.data;
    } catch (error) {
      console.error('Error updating tax invoice:', error);
      throw error;
    }
  },

  // Delete tax invoice (soft delete)
  deleteTaxInvoice: async (id) => {
    try {
      const response = await api.delete(`/tax-invoices/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting tax invoice:', error);
      throw error;
    }
  },

  // Get tax invoice statistics
  getTaxInvoiceStats: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      
      const response = await api.get(`/tax-invoices/stats?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching tax invoice stats:', error);
      throw error;
    }
  },

  // Generate invoice number (get current value for display)
  getCurrentInvoiceNumber: async () => {
    try {
      const response = await api.get('/auto-increment/TAX-INVOICE');
      return response.data;
    } catch (error) {
      console.error('Error fetching current invoice number:', error);
      throw error;
    }
  },

  // Get next invoice number (for creating new invoice)
  getNextInvoiceNumber: async () => {
    try {
      const response = await api.post('/auto-increment/TAX-INVOICE/next');
      return response.data;
    } catch (error) {
      console.error('Error getting next invoice number:', error);
      throw error;
    }
  }
};

export default taxInvoiceService;
